import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';

export default buildFacetDesignOverride()
  .nameOverride('title', { _component: () => DialogTitle }, overrideReadOnly)
  .done();
